import { MODULE_NAME } from './const';
import StoreModuleService from '../StoreModuleService';

const buildGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const useAccountEmailDomain = buildGetterObject('useAccountEmailDomain');
export const useAccountEmailDomains = buildGetterObject('useAccountEmailDomains');
export const useAccountEmailDomainsArr = buildGetterObject('useAccountEmailDomainsArr');
export const useReplyToEmails = buildGetterObject('useReplyToEmails');
export const useUnsubscribeContactEmails = buildGetterObject('useUnsubscribeContactEmails');

const getters = {
	[useAccountEmailDomains.getter]: (state) => state.accountEmailDomain,
	[useAccountEmailDomain.getter]: (state, getters) => (id) => getters[useAccountEmailDomains.getter][id],
	[useAccountEmailDomainsArr.getter]: (state, getters) => Object.values(getters[useAccountEmailDomains.getter]),
	[useReplyToEmails.getter]: (state) => state.accountReplyToEmails,
	[useUnsubscribeContactEmails.getter]: (state) => state.accountUnsubscribeContactEmails,
};

export default getters;
